<template>
    <div id="bulk-sms-postacell">
        <div class="header">
            <div class="title">{{ $t("message.bulkSms") }}</div>
            <div class="subtitle">{{ $t("message.sendBulkSmsCustomers")}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BulkSmsPostacell",
    components: {},
    data() {
        return {};
    },
    computed: {},
    methods: {},
};
</script>
<style scoped lang="scss">
#bulk-sms-postacell {
    .header {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            padding-left: 5px;
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
